import { PriceService } from "../models/priceService.model";
import { PriceUploadExcelViewModel } from "./priceUploadExcel.viewModel";
export class PriceServiceDetailExcelViewModel {
    areaCodes: string[] = [];
    WeightCodes:string[] = [];
    priceServiceViewModel: PriceService = new PriceService();
    priceUploadExcelViewModel: PriceUploadExcelViewModel[] = [];
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/priceServiceDetailExcel.viewModel.ts